var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function warn(msg) {
    // 保留原作者意图说明：诊断告警走 console（仓库未开 no-console 规则，无需 disable）
    console.warn('[nav-state] ' + msg);
}
function scalarsOnly(query) {
    var out = {};
    for (var _i = 0, _a = Object.keys(query || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        var v = query[k];
        // 与 readState 同口径：重复参数（?id=a&id=b）取第一个非空元素，不整键丢弃
        if (Array.isArray(v))
            v = v.find(function (el) { return el !== undefined && el !== null; });
        if (v === undefined || v === null)
            continue;
        if (typeof v === 'object') {
            warn("refusing non-scalar query value for \"".concat(k, "\""));
            continue;
        }
        out[k] = String(v);
    }
    return out;
}
export function readState(route, keys) {
    var out = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var k = keys_1[_i];
        var v = route && route.query ? route.query[k] : undefined;
        if (v === undefined || v === null || v === '' || (Array.isArray(v) && !v.length)) {
            warn("missing query param \"".concat(k, "\" on ").concat(route && route.path));
            return null;
        }
        out[k] = Array.isArray(v) ? String(v[0]) : String(v);
    }
    return out;
}
export function pushState(router, to) {
    router.push({ path: to.path, name: to.name, query: scalarsOnly(to.query) });
}
export function withQuery(route, to) {
    return { path: to.path, name: to.name, query: scalarsOnly(route.query) };
}
function firstScalar(v) {
    if (Array.isArray(v))
        v = v.find(function (el) { return el !== undefined && el !== null && el !== ''; });
    return v === undefined || v === null ? '' : String(v);
}
// N4：canonical classId/className 读口 —— camelCase 优先、legacy 小写 key 兜底；
// 写端（API body）与返回路径统一走这里，canonical-only URL 不再读出 undefined
export function classIdOf(route) {
    var q = (route && route.query) || {};
    return firstScalar(q.classId) || firstScalar(q.classid);
}
export function classNameOf(route) {
    var q = (route && route.query) || {};
    return firstScalar(q.className) || firstScalar(q.classname);
}
export var listState = {
    read: function (route, keys, defaults) {
        var out = __assign({}, (defaults || {}));
        var url = scalarsOnly(route.query || {});
        for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
            var k = keys_2[_i];
            if (url[k] !== undefined)
                out[k] = url[k];
        }
        return out;
    },
    // 返回落地 query：调用方（列表 _pushList）据此投影 _navState，保证 URL 与内存同口径
    push: function (router, route, patch) {
        var query = scalarsOnly(route.query || {});
        for (var _i = 0, _a = Object.keys(patch); _i < _a.length; _i++) {
            var k = _a[_i];
            // R2：patch 数组解包取首个非空元素（与 scalarsOnly 同式、与 readState 同族（病态数组分叉为存量）），对象丢弃并告警
            var v = patch[k];
            if (Array.isArray(v))
                v = v.find(function (el) { return el !== undefined && el !== null; });
            if (v === undefined || v === null || v === '')
                delete query[k];
            else if (typeof v === 'object')
                warn("refusing non-scalar patch value for \"".concat(k, "\""));
            else
                query[k] = String(v);
        }
        router.push({ path: route.path, query: query });
        return query;
    },
    defaultsFrom: function (router, route, defaults) {
        var url = scalarsOnly(route.query || {});
        var missing = {};
        var hasMissing = false;
        for (var _i = 0, _a = Object.keys(defaults || {}); _i < _a.length; _i++) {
            var k = _a[_i];
            if (url[k] === undefined) {
                missing[k] = String(defaults[k]);
                hasMissing = true;
            }
        }
        var state = __assign(__assign({}, missing), url);
        if (hasMissing)
            router.replace({ path: route.path, query: state });
        return state;
    }
};
function draftKey(pageKey, key) {
    return "draft:".concat(pageKey, ":").concat(key);
}
// 中键/右键“在新标签打开”href 解析：router.resolve 可能缺失（裸 push-only mock）或返回 undefined，
// 统一防御，永远返回可放进 <a href> 的字符串。
export function routeHref(router, to) {
    if (!router || typeof router.resolve !== 'function')
        return '#';
    try {
        var resolved = router.resolve(to);
        return (resolved && resolved.href) || '#';
    }
    catch (e) {
        return '#';
    }
}
// 区分“纯左键无修饰键点击”（走 SPA 导航）与中键/Ctrl/Meta/Shift/Alt 点击（交给原生 <a href> 新开 tab）。
// 配合 @click.stop 使用：.stop 无条件阻断冒泡到父级，handler 里仅纯左键 preventDefault + push。
// （不能用 @click.left.exact.prevent——那会把 .stop 也拖到守卫之后，修饰键点击漏冒泡。）
export function isPlainLeftClick(e) {
    return ((e.button === undefined || e.button === 0) &&
        !e.ctrlKey &&
        !e.metaKey &&
        !e.shiftKey &&
        !e.altKey);
}
export function saveDraft(pageKey, payload, explicitKey) {
    var key = explicitKey || Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
    sessionStorage.setItem(draftKey(pageKey, key), JSON.stringify(payload));
    return key;
}
export function loadDraft(pageKey, key) {
    if (!key)
        return null;
    var raw = sessionStorage.getItem(draftKey(pageKey, key));
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (e) {
        return null;
    }
}
export function clearDraft(pageKey, key) {
    if (key)
        sessionStorage.removeItem(draftKey(pageKey, key));
}
function labelOf(v) {
    if (typeof v === 'string')
        return v !== '' ? v : null;
    if (typeof v === 'number' && isFinite(v))
        return String(v);
    return null;
}
function fromSource(source, route, ctx) {
    if (typeof source !== 'string' || source === '')
        return null;
    var query = (route && route.query) || {};
    var meta = (route && route.meta) || {};
    if (source.indexOf('query.') === 0)
        return labelOf(query[source.slice(6)]);
    if (source.indexOf('meta.') === 0)
        return labelOf(meta[source.slice(5)]);
    if (source.indexOf('ctx.') === 0)
        return labelOf(ctx ? ctx[source.slice(4)] : undefined);
    // 纯键名：拉取标签（ctx，导航时刻最新）优先于 query 快照标签（书签久置会过期）
    return (ctx ? labelOf(ctx[source]) : null) || labelOf(query[source]);
}
function fromSourceList(from, route, ctx) {
    var sources = Array.isArray(from) ? from : from !== undefined ? [from] : [];
    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
        var source = sources_1[_i];
        var label = fromSource(source, route, ctx);
        if (label !== null)
            return label;
    }
    return null;
}
// 未传段模板时按 route.meta.menuDatas 推导段列表（routeName 取 key）
function menuSegments(menuDatas) {
    if (!Array.isArray(menuDatas))
        return [];
    return menuDatas.map(function (raw) {
        var item = (raw && typeof raw === 'object' ? raw : {});
        var spec = {};
        var routeName = labelOf(item.key);
        var name = labelOf(item.name);
        if (routeName !== null)
            spec.routeName = routeName;
        if (name !== null)
            spec.name = name;
        return spec;
    });
}
// 纯函数：route（meta.menuDatas/pageTitle + query 标签）+ ctx（拉取标签）→ 面包屑数组。
// 缺标签的段整体省略、缺失/异常输入不抛错（深链与慢网降级口径）。
export function buildBreadcrumb(route, ctx) {
    var meta = (route && route.meta) || {};
    // 路由声明无面包屑（adminConsole settings 的 breadcrumbType '0'）：空数组
    if (meta.breadcrumbType === '0')
        return [];
    var specs = (ctx && ctx.segments) || menuSegments(meta.menuDatas);
    var out = [];
    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
        var spec = specs_1[_i];
        var name_1 = (spec && (labelOf(spec.name) || fromSourceList(spec.from, route, ctx))) || null;
        if (name_1 === null)
            continue;
        var routeName = spec ? labelOf(spec.routeName) : null;
        out.push(routeName !== null ? { routeName: routeName, name: name_1 } : { name: name_1 });
    }
    return out;
}
